"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featuresMocks = void 0;

var _msw = require("msw");

var getFeaturesMock = _msw.rest.get('/enterprise/dashboard/settings/organisations/enabled-features', function (req, res, ctx) {
  return res(ctx.json({
    success: true,
    settings: [{
      id: 20200220,
      name: 'billing_insights',
      label: 'Billing Insights (ex. Platform Usage)',
      enabled: true
    }, {
      id: 20201123,
      name: 'international',
      label: 'International',
      enabled: true
    }, {
      id: 20201216,
      name: 'can_use_custom_fields',
      label: 'Custom Fields',
      enabled: true
    }, {
      id: 20210301,
      name: 'assist_feature',
      label: 'Assist feature',
      enabled: true
    }, {
      id: 20210309,
      name: 'eloqua_integration',
      label: 'Eloqua Integration',
      enabled: true
    }, {
      id: 20210413,
      name: 'salesloft_integration',
      label: 'Salesloft Integration',
      enabled: true
    }, {
      id: 20210630,
      name: 'declared_data',
      label: 'Declared Data',
      enabled: true
    }, {
      id: 20210715,
      name: 'alyce_for_marketing',
      label: 'Alyce For Marketing',
      enabled: true
    }, {
      id: 20210729,
      name: 'gifting_on_the_fly',
      label: 'Gifting on the fly',
      enabled: true
    }, {
      id: 20210817,
      name: 'accept_only',
      label: 'Accept Only',
      enabled: true
    }, {
      id: 20211109,
      name: 'hubspot_integration',
      label: 'Hubspot Integration',
      enabled: true
    }, {
      id: 20211109,
      name: 'dynamics_integration',
      label: 'Dynamics Integration',
      enabled: true
    }, {
      id: 20220128,
      name: 'analytics_reporting',
      label: 'Analytics reporting',
      enabled: true
    }, {
      id: 20220207,
      name: 'public_api',
      label: 'Public API',
      enabled: true
    }, {
      id: 20220222,
      name: 'workato_integration',
      label: 'Workato Integration',
      enabled: true
    }, {
      id: 202002106,
      name: 'marketo_integration',
      label: 'Marketo Integration',
      enabled: true
    }, {
      id: 202004271,
      name: 'activate_product',
      label: 'Activate Product',
      enabled: true
    }, {
      id: 202109243,
      name: 'one_to_many_meeting_booker',
      label: '1:many meeting booker',
      enabled: true
    }, {
      id: 202109343,
      name: 'outreach_integration',
      label: 'Outreach Integration',
      enabled: true
    }, {
      id: 20200521,
      name: 'salesforce_app_access',
      label: 'Salesforce Application Access',
      enabled: false
    }, {
      id: 20200617,
      name: 'show_remaining_deposits',
      label: 'Show remaining deposits',
      enabled: false
    }, {
      id: 20200812,
      name: 'mail_sender_authentication',
      label: 'Mail Sender Authentication',
      enabled: false
    }, {
      id: 20210210,
      name: 'show_deposit_ledger',
      label: 'Show deposit ledger',
      enabled: false
    }, {
      id: 20210621,
      name: 'automated_billing',
      label: 'Automated Billing Enable at 2022-06-01',
      enabled: false
    }, {
      id: 20210810,
      name: 'disable_margin',
      label: 'Disable Margin',
      enabled: false
    }, {
      id: 20210816,
      name: 'multiple_gift_links',
      label: 'Multiple gift links',
      enabled: false
    }, {
      id: 20220124,
      name: 'prospecting_campaign',
      label: 'Prospecting campaign',
      enabled: false
    }, {
      id: 20220508,
      name: 'budget_management_limit',
      label: 'Budget management limit',
      enabled: false
    }, {
      id: 20220509,
      name: 'budget_management_setup',
      label: 'Budget management setup',
      enabled: false
    }, {
      id: 202001097,
      name: 'contact_enrichment',
      label: 'Contact enrichment',
      enabled: false
    }, {
      id: 202002209,
      name: 'swag add-on',
      label: 'Swag Add-on',
      enabled: false
    }, {
      id: 202006173,
      name: 'sf_api_integration',
      label: 'Salesforce Api Integration',
      enabled: false
    }, {
      id: 20220602,
      name: 'gift_redemption_codes_2_0',
      label: 'Gift Redemption Codes 2.0',
      enabled: false
    }]
  }));
});

var featuresMocks = [getFeaturesMock];
exports.featuresMocks = featuresMocks;